import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { PermissionModels } from '@share-models';
import { routerSegments } from '../consts/routes';
import { PermissionAccessModels } from '../models/permission-access.model';
import { PermissionAccessService } from '../services/permission-access.service';

/**
 * Lets a route open only for a user holding one of the permissions in its
 * `data[PermissionAccessModels.RouteDataKey.Permissions]`; anyone else lands on home.
 */
export const permissionGuard: CanActivateFn = (
  route,
): Observable<boolean | UrlTree> => {
  const router: Router = inject(Router);
  const permissions: PermissionModels.Permissions[] =
    (route.data[PermissionAccessModels.RouteDataKey.Permissions] as
      | PermissionModels.Permissions[]
      | undefined) ?? [];

  return inject(PermissionAccessService)
    .isAllowed$(permissions)
    .pipe(
      take(1),
      map(
        (isAllowed) =>
          isAllowed || router.createUrlTree(['/', routerSegments.home]),
      ),
    );
};
